<template>
  <div v-if="brochures.length" class="container">
    <BaseTitle v-if="title" class="grid-title" :tag="tag">{{
      title
    }}</BaseTitle>
    <div class="brochures-grid">
      <BrochureItem
        v-for="brochure in brochures"
        :key="brochure.id"
        :brochure="brochure"
        class="brochure-item"
        :impression-source="BrochureImpressionSource.AlsoInteresting"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  BrochureImpressionSource,
  type SimilarBrochuresForShopInput,
  useSimilarBrochuresForShopQuery,
} from "~/graphql/generated";

const props = defineProps<{
  title?: string;
  input: SimilarBrochuresForShopInput;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}>();

// Mark this as reactive, so the query will re-run when the value changes
const variables = computed(() => {
  return {
    brochuresInput: {
      ...props.input,
    },
  };
});

const { data } = await useSimilarBrochuresForShopQuery({
  variables,
});

const brochures = computed(() => data.value?.similarBrochuresForShop ?? []);
</script>

<style lang="scss" scoped>
.brochures-grid {
  display: grid;
  gap: 1.5rem;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  @include for-extra-small-screen {
    grid-template-columns: 1fr 1fr;
  }
}

.grid-title::first-letter {
  text-transform: capitalize;
}
</style>
